import React from 'react';
import LastSeenCell from 'views/assets/AssetList/components/LastSeenCell';
import { Features } from 'types/config';
import { Column } from 'components/DataTable/DataTable';
import { Device } from 'types/device';
import LocationCell from './LocationCell';

export function getTableColumns(availableFeatureObj: Features): Column<Device>[] {
  return [
    {
      title: 'DEVICE ID',
      width: '240px',
      field: 'device_id',
    },
    {
      title: 'LOCATION',
      renderer: (cellValue, RowValues: Device) => <LocationCell value={RowValues} />,
      width: '260px',
      field: 'location',
    },
    {
      title: 'LAST SEEN',
      width: '140px',
      renderer: (cellValue, RowValues: Device) => <LastSeenCell timestamp={RowValues.last_update_timestamp} />,
      field: 'last_update', // API is mapped to last_location_update_timestamp for last_update
    }
  ];
}
